/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import ko from 'knockout';
import jobObj from '../../../objects/jobObj.js';
import jobUtil from '../../../objects/jobUtil.js';
import reviewUtil from '../../../objects/reviewUtil.js';

/*
This component which uses tabEditor
*/


class reviewEditorModule {

    constructor(params) {
        // Profile
        this.componentName = "review-editor";
        this.context = context;
        this.id = ko.observable(this.context.util.guid());
        this.visible = ko.observable(false);

        this.reviewObj = ko.observable();

        this.selectedJob = this.defaultJob();

        this.editorMessageObj = ko.observable();
        this.workflowMessageObj = ko.observable();

        this.editor = {};

        this.context.eventManager.subscribe((passedObj) =>{
            this.handleReviewJob(passedObj);
        },this, "reviewApproveJob");

        this.init(params)
    }

    init(params)
    {
        console.log("review-editor:init");
    }


    defaultJob() {

        let returnJob = new jobObj({"jobid": 0,
        "subid": 0,
        "title": "",
        "isexempt": false,
        "statusid": 0,
        "jobfieldid": 0,
        "datecreated": "",
        "datelastused": "",
        "paygradeid": 0,
        "alternategrade": 0,
        "positionsummary": "",
        "educationandexperience": "",
        "physicalrequirements": "",
        "jobguid": ""});

        return returnJob;
    }


    handleReviewJob(passedObj) {

        console.log("from bootUtil review-editor:handleReviewJob:  passedObj: %o", passedObj);
        this.visible(true);

        this.selectedJob = passedObj;

        let reviewUtilObj = new reviewUtil(this.context);
        let self = this;

        reviewUtilObj.checkReviewForNextInProcess().then( response => {
            console.log("review-editor:handleReviewJob:");
            console.log(response);
            self.reviewObj(response);
        }).then(response => {
            console.log("review-editor:handleReviewJob:getVersion");
            this.editorMessageObj({ event:"getVersion", jobid:self.reviewObj().jobid, reviewObj:self.reviewObj });
            this.workflowMessageObj({event:"refresh", selectedJob: self.selectedJob});
        });

        this.editor = ko.dataFor(document.getElementById("ReviewEditorID"));

        this.editorMessageObj({event:"getVersion"});
        

    }

}

export default { viewModel: reviewEditorModule, template: require('!raw-loader!./review-editor.html') };


// WEBPACK FOOTER //
// ./src/components/review/review-editor/review-editor.js